
import React, { useRef } from 'react';
import { useState, useEffect } from 'react';
import Loader from 'react-loader-spinner';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import ActionNotification from '../../components/ActionNotification';
import { convertBase64ToBlob, sendMessageToWebViewWrapper } from '../../helpers/Functions';
import { HOMEPAGE, ONBORADING_SCREEN } from '../../navigation/Constants';
import { reset } from '../../redux/app';
import { resetCarpet } from '../../redux/carpet';
import { resetUserData, setUserData } from '../../redux/member';
import { resetMoodData } from '../../redux/mood';
import { resetSignupData } from '../../redux/signup';
import { resetSignupQuestions } from '../../redux/signupQuestions';
import { RootState } from '../../redux/store';
import { getVerifyPhotos, uploadVerificationImage } from '../../services/mediaService';
import account from '../../services/accountService';
import { GenderType } from '../../helpers/Enums';
import LoadingIndiactorModal from '../../components/modals/LoadingIndicatorModal';


export type VerifyPhotosProps = {
    imageUrl: string;
    name: string;
    id: number;
}

type ProfilePhotoVerifyProps = {
    isFromNeedToVerifyProfile?: boolean;
}

const ProfilePhotoVerify = (props: ProfilePhotoVerifyProps) => {
    const history = useHistory();
    const imageEle = useRef<any>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const { memberCode: myMemberCode } = useSelector((state: RootState) => state.member);
    const [selfieImage, setSelfieImage] = useState<string>();
    const [vefifyPhotos, setVerifyPhotos] = useState<VerifyPhotosProps>();
    const [isUploaded, setIsUploaded] = useState<boolean>(false);
    const [showImageUploadingLoader, setShowImageUploadingLoader] = useState<boolean>(false);
    useEffect(() => {
        getPhotos();
    }, [])

    const dispatch = useDispatch();
    const member = useSelector((state: RootState) => state.member);

    const getPhotos = async () => {
        setIsLoading(true);
        const { data } = await getVerifyPhotos(myMemberCode);
        setVerifyPhotos(data);
        setIsLoading(false);
    };

    const sendVerifyImageToServer = async () => {

        try {
            if (vefifyPhotos && selfieImage) {
                setShowImageUploadingLoader(true);
                const { data } = await uploadVerificationImage(myMemberCode, vefifyPhotos.id, convertBase64ToBlob(selfieImage));
                setIsUploaded(true);
                member.profileRequierdVerification = true;
                dispatch(setUserData(member));
                setShowImageUploadingLoader(false);
            }
        }
        catch (error: any) {
            console.error(error);
            //show genriec alert
        }
    };

    const onSelectFile = async (e: any) => {

        e.preventDefault();

        let files;
        if (e.dataTransfer) {
            files = e.dataTransfer.files;
        } else if (e.target) {
            files = e.target.files;
        }
        const reader = new FileReader();

        if (!reader) return;

        reader.onload = () => {
            setSelfieImage(reader.result?.toString());
            e.target.value = null;

        };
        reader.readAsDataURL(files[0]);

    };

    const openSelectFile = () => {
        imageEle.current.click();
    };


    if (isLoading) return <div style={{ height: "80vh", margin: "auto", display: 'flex', justifyContent: "center", alignItems: "center" }}>
        <Loader type="ThreeDots" color="#f47373" height={60} width={60} />
    </div>

    if (isUploaded && props?.isFromNeedToVerifyProfile) {
        return <ActionNotification
            title={"קיבלנו! מיד מעבירים את התמונה לבדיקה"}
            description={"תהליך האימות יכול לקחת עד 3 ימים. בסופו, נשלח אליך הודעת sms שבה נעדכן אם האימות עבר בהצלחה"}
            onNext={() => {
                member.profileRequierdVerification = true;
                dispatch(setUserData(member));
                history.push(HOMEPAGE);
            }}
            showButton={true}
            buttonText={"המשך"}
            isError={false}
        />
    } else if (isUploaded) {
        return <ActionNotification
            title={"קיבלנו! מיד מעבירים את התמונה לבדיקה"}
            description={"תהליך האימות יכול לקחת עד 3 ימים. בסופו, נשלח אליך הודעת sms שבה נעדכן אם האימות עבר בהצלחה"}
            onNext={() => history.goBack()}
            showButton={true}
            buttonText={"המשך"}
            isError={false}
        />
    }

    return (
        <div className="meet_sec" style={{ backgroundImage: "unset" }}>
            <div className="meet_top_red"></div>
            <h1 className="meet_title" >אימות פרופיל</h1>
            <div className="meet_picts_group">
                <div className="meet_pict">
                    <img
                        src={vefifyPhotos?.imageUrl}
                        loading="lazy"
                        alt=""
                        className="item_pict"
                    />
                </div>
                {
                    selfieImage ? <div className="meet_pict">
                        <img
                            src={selfieImage}
                            loading="lazy"
                            alt=""
                            className="item_pict"
                        />

                    </div> : null
                }

            </div>
            <div className="meet_form w-form">
                <div className="form_field_content meet">
                    <div className="field_block meet">
                        <div className="meet_label">
                            {selfieImage && <h3>האם התמונות דומות אחת לשניה?</h3>}
                            {selfieImage ? null : member.genderId === GenderType.MALE ? "לצורך האימות, צלם את עצמך בסלפי מחקה את התנועה שעושה הדמות שבתמונה למעלה. התמונה לאימות בלבד, לא תוצג לאף אחד וגם לא תישמר אצלנו." : "לצורך האימות, צלמי את עצמך בסלפי מחקה את התנועה שעושה הדמות שבתמונה למעלה. התמונה לאימות בלבד, לא תוצג לאף אחד וגם לא תישמר אצלנו."}
                        </div>
                        <div className='meet_label' style={{ display: "flex", flexDirection: "column", justifyItems: "center", paddingTop: 15 }}>
                            {selfieImage ? <p>זה לא צריך להיות חיקוי מושלם, אבל כדאי שהתנועות יהיו דומות</p> :
                                <div>
                                    <span style={{ fontWeight: "bold" }}>הבטחה שלנו:</span>
                                    <span>תמונה זו הינה לאימות לאימות פרופיל בלבד-היא לא תעלה לפרופיל שלך ולא תוצג לאיש</span>
                                </div>}
                        </div>
                    </div>
                </div>
                <div className="form_buttons_group meet" style={{ display: "flex", flexDirection: "column" }}>

                    <input autoComplete="off"
                        type="submit"
                        onClick={selfieImage ? sendVerifyImageToServer : openSelectFile}
                        value={selfieImage ? "שליחת תמונה לאימות" : "לאימות"}
                        data-wait
                        className="button_full meet w-button"

                    />
                    {!props?.isFromNeedToVerifyProfile && <a href="#" onClick={selfieImage ? openSelectFile : () => history.goBack()} className="skip_link">{selfieImage ? "בעצם, אני רוצה לצלם שוב" : "בפעם אחרת"}</a>}
                    <input autoComplete="off" style={{ display: 'none' }}
                        type='file'
                        accept="image/*"
                        capture="user" ref={imageEle} onChange={onSelectFile} />

                </div>
            </div>
            {showImageUploadingLoader && <LoadingIndiactorModal text="מעלה תמונה" />}
        </div>

    )
}


export default ProfilePhotoVerify;

